module.exports = __webpack_public_path__ + "static/media/Humane-Ai-Pin-Business.792856a6.webp";